import _slicedToArray from "/codebuild/output/src1153720889/src/landings/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import shallowEqual from "./shallowEqual";
import { deserializeUrlNameMap } from "./urlName";
var cachedSearchString;
var cachedUrlNameMapString;
var cachedSearchStringToObjectFn;
var cachedParsedQuery = {};
var memoSearchStringToObject = function memoSearchStringToObject(searchStringToObject, searchString, urlNameMapStr) {
  if (cachedSearchString === searchString && cachedSearchStringToObjectFn === searchStringToObject && cachedUrlNameMapString === urlNameMapStr) {
    return cachedParsedQuery;
  }
  cachedSearchString = searchString;
  cachedSearchStringToObjectFn = searchStringToObject;
  var newParsedQuery = searchStringToObject(searchString != null ? searchString : "");
  cachedUrlNameMapString = urlNameMapStr;
  var urlNameMap = deserializeUrlNameMap(urlNameMapStr);
  for (var _i = 0, _Object$entries = Object.entries(newParsedQuery); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (urlNameMap == null ? void 0 : urlNameMap[key]) {
      delete newParsedQuery[key];
      key = urlNameMap[key];
      newParsedQuery[key] = value;
    }
    var oldValue = cachedParsedQuery[key];
    if (shallowEqual(value, oldValue)) {
      newParsedQuery[key] = oldValue;
    }
  }
  cachedParsedQuery = newParsedQuery;
  return newParsedQuery;
};
export { memoSearchStringToObject };